const PLATFORMS = {
  ED: 'HMH',
  FLIGHT: 'HNM',
  NWEA: 'NWEA',
  AI_TOOLS: 'AI-TOOLS',
  WRITABLE: 'WRITABLE',

  // SUB PLATFORMS
  FLIGHT_CONTENT_SHARE: 'HNM-CONTENT-SHARE',
  SUPPORT_TOOL: 'SUPPORT-TOOL',
};

const DEFAULT_CONFIGURATIONS = {
  [PLATFORMS.ED]: {
    name: PLATFORMS.ED,
    platform: PLATFORMS.ED,
    predicate: 'hmhco.com',
    showDesktopNavbar: true,
    showMobileNavbar: true,
    showLMS: true,
  },
  [PLATFORMS.FLIGHT]: {
    name: PLATFORMS.FLIGHT,
    predicate: 'heinemann',
    showDesktopNavbar: false,
    showMobileNavbar: false,
    showLMS: true,
  },
  [PLATFORMS.NWEA]: {
    name: PLATFORMS.NWEA,
    predicate: 'nwea',
    showDesktopNavbar: false,
    showMobileNavbar: false,
    showLMS: false,
  },
  [PLATFORMS.AI_TOOLS]: {
    name: PLATFORMS.AI_TOOLS,
    predicate: 'hmhco.ai',
    showDesktopNavbar: false,
    showMobileNavbar: false,
    showLMS: false,
  },
  [PLATFORMS.WRITABLE]: {
    name: PLATFORMS.WRITABLE,
    predicate: 'writable.com',
    showDesktopNavbar: false,
    showMobileNavbar: false,
    showLMS: false,
  },
};

/**
 * to ensure backwards compatibility, we basically serve the same config objects we did before
 * This pattern leaves us space to integrate other configs later
 */
const CONFIGURATIONS = {
  [PLATFORMS.ED]: DEFAULT_CONFIGURATIONS[PLATFORMS.ED],
  [PLATFORMS.FLIGHT]: DEFAULT_CONFIGURATIONS[PLATFORMS.FLIGHT],
  [PLATFORMS.NWEA]: DEFAULT_CONFIGURATIONS[PLATFORMS.NWEA],
  [PLATFORMS.AI_TOOLS]: DEFAULT_CONFIGURATIONS[PLATFORMS.AI_TOOLS],
  [PLATFORMS.WRITABLE]: DEFAULT_CONFIGURATIONS[PLATFORMS.WRITABLE],

  // SUB PLATFORMS
  [PLATFORMS.FLIGHT_CONTENT_SHARE]: DEFAULT_CONFIGURATIONS[PLATFORMS.FLIGHT],
  [PLATFORMS.SUPPORT_TOOL]: DEFAULT_CONFIGURATIONS[PLATFORMS.ED],
};

const ENVIRONMENTS = {
  local: 'local',
  dev: 'dev',
  int: 'int',
  cert: 'cert',
  devCert: 'devCert',
  prod: 'prod',
};

Object.freeze(PLATFORMS);
Object.freeze(ENVIRONMENTS);

module.exports = {
  PLATFORMS,
  ENVIRONMENTS,
  CONFIGURATIONS,
  DEFAULT_CONFIGURATIONS,
};
